jQuery(document).ready(function () {
	// Open Filter in mobile
	jQuery(document).on("click", ".btn-mobile-filter-action", function (e) {
		e.preventDefault();
		jQuery(".mobile-filter").addClass("filter-expanded");
		jQuery("body").addClass("filter-expanded-open");
	});

	// Close Filter in mobile
	jQuery(document).on("click", ".close-filter-action", function (e) {
		e.preventDefault();
		jQuery(".mobile-filter").removeClass("filter-expanded");
		jQuery("body").removeClass("filter-expanded-open");
	});

	// Close Filter When click on body
	jQuery(document).on("click", function (event) {
		var $trigger = jQuery(".mobile-filter-header");
		var $triggerTwo = jQuery(".mobile-filter");
		if (
			$trigger !== event.target &&
			!$trigger.has(event.target).length &&
			$triggerTwo !== event.target &&
			!$triggerTwo.has(event.target).length
		) {
			jQuery(".mobile-filter").removeClass("filter-expanded");
			jQuery("body").removeClass("filter-expanded-open");
		}
	});

	jQuery(".input-change").change(function () {
		let count = jQuery(".filter-container input:checked").length;
		jQuery(".filter-no").text(count);
		jQuery('[name="rooms-filter"]').submit();
	});

	// let page = 2;
	let isLoading = false;

	let addSearch = function (data) {
		let clean_uri = window.location.toString();
		if (clean_uri.indexOf("?") > 0) {
			clean_uri = clean_uri.substring(0, clean_uri.indexOf("?"));
		}
		let processedData = {};
		// console.log(processedData);
		data.forEach(function (obj) {
			let $key = obj.name;

			let name = obj.name.replaceAll("[", " ").replaceAll("]", " ");
			name = name.split(" ");
			if (name.length) {
				if (name[1] && name[1] !== "") $key = name[1];
				else $key = name[0];
			}
			if (!processedData[$key]) processedData[$key] = [];
			if (!($key === "sort_by" && obj.value === "Sort") && processedData[$key].indexOf(obj.value) < 0)
				processedData[$key].push(obj.value);
		});
		let tuples = [];
		jQuery.each(processedData, function (key, arr) {
			tuples.push(key + "=" + arr.join(","));
		});
		let params = tuples.join("&");
		let url = clean_uri + "?" + params;
		// reload page with new params
		// console.log(url);
		window.history.replaceState({}, document.title, url);
	};

	let loadRooms = function (isAppend = false) {
		isLoading = true;
		jQuery(".loader-wrapper").removeClass("d-none");
		if (!isAppend) {
			jQuery("#rooms_container").html("");
			jQuery("#rooms-number").text("");
		}

		let form = jQuery('form[name="rooms-filter"]');
		let data = form.serializeArray();
		// console.log(data);
		// let per_page = jQuery('[name="per_page"]').val();

		let prefiltered_data = form.data("prefilter");
		if (typeof prefiltered_data == "object") {
			data = data.concat(prefiltered_data);
		}
		// console.log(data);

		// data = data.concat([{ name: "paged", value: page }]);
		addSearch(data);
		data = data.concat([{ name: "action", value: "belgard_room_list" }]);

		// console.log(data);
		jQuery.ajax({
			type: "POST",
			url: belgard_object.ajax_url,
			data: data, // serializes the form's elements.
			success: function (res) {
				if (isAppend) {
					jQuery("#rooms_container").append(res.data.rooms);
				} else {
					jQuery("#rooms_container").html(res.data.rooms);
				}

				if (res.data.totalCount == 0) {
					jQuery("#rooms-number").text("");
				} else if (res.data.totalCount == 1) {
					var roomCountLabel = jQuery("#rooms-number").data("label-singular");
					jQuery("#rooms-number").text(res.data.totalCount + " " + roomCountLabel);
				} else if (res.data.totalCount > 1) {
					var roomCountLabel = jQuery("#rooms-number").data("label-plural");
					jQuery("#rooms-number").text(res.data.totalCount + " " + roomCountLabel);
				}

				// if (page * parseInt(per_page) < res.data.totalCount) isLoading = false;

				// page += 1;
				jQuery(".loader-wrapper").addClass("d-none");
			},
		});
	};
	let scrollDown = function () {
		if (isLoading) return;
		if (jQuery(window).scrollTop() + window.innerHeight >= document.body.scrollHeight) {
			loadRooms(true);
		}
	};

	// jQuery(window).scroll(scrollDown);
	// jQuery(document.body).on("touchmove", scrollDown);
	jQuery('form[name="rooms-filter"]').submit(function (e) {
		e.preventDefault();
		page = 1;
		loadRooms(false);
	});
});

// Tooltip logic
document.addEventListener(
	"DOMContentLoaded",
	function () {
		var tippyConfig = {
			// trigger: "click focus",
			trigger: "mouseenter focus",
			content(reference) {
				const id = reference.getAttribute("id") + "-content";
				const template = document.getElementById(id);
				return template.innerHTML;
			},
			allowHTML: true,
			placement: "bottom",
			animation: "shift-away",
			interactive: true,
			maxWidth: 800,
			onCreate(instance) {
				// console.log(instance);
				instance.reference.removeAttribute("title");
			},
		};

		if (window.innerWidth > 767) {
			tippyConfig.placement = "right";
		}
		// console.log(tippyConfig);

		tippy(".tooltip", tippyConfig);
	},
	false
);
